export default __webpack_public_path__ + "static/media/slider2.4c922b8d.jpg";